const type = 'RESET_SPLIT_INVOICE';

const resetSplitInvoice = () => ({
  type,
});

export { type };
export default resetSplitInvoice;
